import React from 'react';
import * as BuilderUI from '../../../../../../components/Builder/BuilderUI';
import { assertCondition } from '../../../../../../utils/types';
import { setSignificanceFunnelStep } from '../../../../../../redux/slices/oldBuilder';
import { useAppDispatch } from '../../../../../../redux/hooks';
import {
  IFunnelStepBriefInfoFieldsFragment,
  IUserAliasReplacementFieldsFragment,
} from '../../../../../../utils/apollo/graphqlSchema';
import FunnelStepMenu from '../../../../../../components/FunnelStepMenu';

interface IProps {
  steps: IFunnelStepBriefInfoFieldsFragment[];
  convertedOnStep: number;
  aliasReplacements: IUserAliasReplacementFieldsFragment[];
}

const SignificanceFunnelMetricStep = ({
  steps,
  convertedOnStep,
  aliasReplacements,
}: IProps) => {
  const dispatch = useAppDispatch();

  const handleSelectStep = (newValue: string) => {
    assertCondition(!isNaN(Number(newValue)));

    dispatch(setSignificanceFunnelStep({ stepIndex: Number(newValue) }));
  };

  return (
    <BuilderUI.BuilderFieldContainer>
      <BuilderUI.BuilderFieldLabel>
        conversion rate on
      </BuilderUI.BuilderFieldLabel>
      <FunnelStepMenu
        steps={steps}
        selectedStep={convertedOnStep.toString()}
        onChange={handleSelectStep}
        aliasReplacements={aliasReplacements}
        placeholder={'Select Step'}
      />
    </BuilderUI.BuilderFieldContainer>
  );
};

export default SignificanceFunnelMetricStep;
